var _path, _rect, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4L19.3623 8.49951L18.7195 9.26556C18.0095 10.1117 16.748 10.2221 15.9019 9.51207L13.6037 7.58371C12.7576 6.8737 12.6472 5.61219 13.3572 4.76604L14 4Z",
    fill: "#797F92"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.6035,
    y: 7.58374,
    width: 3,
    height: 3,
    transform: "rotate(40 13.6035 7.58374)",
    fill: "#797F92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85749 10.1284C9.56749 9.28225 10.829 9.17189 11.6752 9.88189L13.9733 11.8103C14.8194 12.5203 14.9298 13.7818 14.2198 14.6279L12.9342 16.16L7.57192 11.6605L8.85749 10.1284Z",
    fill: "#797F92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22754 14.3549L9.99358 14.9976L7.10104 18.4448C6.92354 18.6564 6.60816 18.684 6.39662 18.5065C6.18509 18.329 6.15749 18.0136 6.33499 17.8021L9.22754 14.3549Z",
    fill: "#797F92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.edeb61b2.svg";
export { ForwardRef as ReactComponent };